<script setup lang="ts">
import { onMounted } from 'vue';

const emit = defineEmits(['loaded']);

onMounted(() => {
  emit('loaded');
});
</script>

<template>
  <a-alert message="Solicitação foi aprovada" show-icon></a-alert>
</template>
